import { Component, OnInit, ErrorHandler } from '@angular/core';
import { UserService } from '../../shared/user.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Search } from '../../shared/user.model';
import swal from 'sweetalert2';

@Component({
  selector: 'app-customer-creation-grid',
  templateUrl: './customer-creation-grid.component.html',
  styleUrls: ['./customer-creation-grid.component.css']
})
export class CustomerCreationGridComponent implements OnInit {

  title="Customer List";
  itemsPerPage: number = 5;
  currentPage: number = 1;
  totalItems: number;
  customerList: any=[];
  data: any;
  s: Search;
  isSearch:boolean = false;
  logbranch:any;

  constructor(private service: UserService, private router: Router,private route: ActivatedRoute,private errorHandler:ErrorHandler) { }

  ngOnInit() {
    this.s = new Search();
    this.isSearch = false;
    this.GetAllCustomerDetails(this.itemsPerPage, 1);
    this.logbranch=localStorage.getItem('BRANCH_ID');
  }



  pageChanged(pageNumber: number) {
    //if (this.isSearch)
      //this.onSearch(this.s, this.itemsPerPage, pageNumber);
   // else
      this.GetAllCustomerDetails(this.itemsPerPage, pageNumber);
  }

  itemsPerPageChanged(itemsPerPage: number, pageNo: number) {
   // if (this.isSearch)
      //this.onSearch(this.s, this.itemsPerPage, pageNo);
    //else
      this.GetAllCustomerDetails(this.itemsPerPage, pageNo);
  }


  GetAllCustomerDetails(itemsPerPage: number, pageNo: number) {
    debugger;
    this.logbranch=localStorage.getItem('BRANCH_ID');
    document.getElementById('loader-spinner').style.display = "block";
    this.service.getAllCustomerDetails(itemsPerPage, pageNo,this.logbranch)
      .subscribe(
        (data: any) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.customerList = data.CustomerGridModel;
          console.log(this.customerList);
          this.totalItems = data.TotalItemsCount;
          this.itemsPerPage = itemsPerPage;
          this.currentPage = pageNo;
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          //this.errorHandler.HandlerError(error);
        });
  }



  onSearch(s, itemsPerPage: number, pageNo: number) { 

    debugger;
    this.logbranch=localStorage.getItem('BRANCH_ID');
        this.isSearch = true;
        let searchText = this.s.SearchText;
        let searchCriteria = this.s.SearchCriteria;
        if (searchText == "" ||searchText == null )
           swal("Warning!", "Please enter the search text.", "warning");
        else if( searchCriteria == "" || searchCriteria == null)
           swal("Warning!", "Please select the search criteria.", "warning");
         // alert("Warning!" );
        else {
          // document.getElementById('loader-spinner').style.display = "block";
          this.service.SearchCustomerCreation(searchCriteria, searchText, itemsPerPage, pageNo,this.logbranch)
            .subscribe(
              (data: any) => {
                if(data.CustomerGridModel.length!=0){              
                this.customerList = data.CustomerGridModel;
                this.totalItems = data.TotalItemsCount;
                this.currentPage = pageNo;
                // document.getElementById('loader-spinner').style.display = "none";
              }
              else
              {
              // document.getElementById('loader-spinner').style.display = "none";         
              }
              }, (error) => {
                // document.getElementById('loader-spinner').style.display = "none";
                if (error.status == 401) {
                  this.errorHandler.handleError(error);
                }
                else if (error.status == 400) {
                  // swal('Warning!', error.error.Message, 'warning');
                }
              });
        }
      }
    
    
    
    }
    


// WEBPACK FOOTER //
// ./src/app/unicore-masters/customer-creation-grid/customer-creation-grid.component.ts